import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5531befc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "column" };
const _hoisted_2 = { style: { "display": "flex" } };
const _hoisted_3 = {
    key: 0,
    class: "label"
};
const _hoisted_4 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
    key: 0,
    value: undefined
};
const _hoisted_7 = ["value"];
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormSelectField',
    props: {
        options: {},
        includedOptions: {},
        excludedOptions: {},
        modelValue: {},
        label: {},
        description: {},
        allowNullSelection: { type: Boolean },
        nullSelectionLabel: {},
        validator: { type: Function },
        validationId: {},
        isDisabled: { type: Boolean }
    },
    emits: ['update:modelValue', 'change'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // Have to bind to the <select> indirectly through this variable, as we can't use it in v-model directly
        // Also, the <select> element doesn't let us associate a 'null' value with an <option> - only 'undefined' - so we need to convert between them
        const boundValue = ref(props.modelValue != null ? props.modelValue : undefined);
        // Event for two-way binding
        const emit = __emit;
        watch(boundValue, (val, prevVal) => {
            emit('update:modelValue', val == undefined ? null : val);
            emit('change');
        });
        watch(() => props.modelValue, () => {
            boundValue.value = props.modelValue != null ? props.modelValue : undefined;
        });
        const allowedOptions = computed(() => {
            if (props.includedOptions) {
                return Object.fromEntries(Object.entries(props.options).filter(([k, v]) => props.includedOptions.includes(v)));
            }
            else if (props.excludedOptions) {
                return Object.fromEntries(Object.entries(props.options).filter(([k, v]) => !props.excludedOptions.includes(v)));
            }
            else {
                return props.options;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.label)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "top")
                ]),
                (_ctx.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["selectField", { 'is-danger': _ctx.validator ? !_ctx.validator(_ctx.validationId ? _ctx.validationId : this, _ctx.modelValue) : false }]),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((boundValue).value = $event)),
                    disabled: _ctx.isDisabled
                }, [
                    (_ctx.allowNullSelection || _ctx.modelValue == null || _ctx.modelValue == undefined)
                        ? (_openBlock(), _createElementBlock("option", _hoisted_6, _toDisplayString(_ctx.nullSelectionLabel || 'Select...'), 1))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedOptions.value, (optionValue, optionLabel) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: optionValue,
                            value: optionValue
                        }, _toDisplayString(optionLabel), 9, _hoisted_7));
                    }), 128))
                ], 10, _hoisted_5), [
                    [_vModelSelect, boundValue.value]
                ]),
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
